var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.125,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E39B2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2919 9.5C27.673 9.5 27.0795 9.74583 26.6419 10.1834C26.2044 10.621 25.9585 11.2145 25.9585 11.8333C25.9611 12.0343 25.9886 12.2341 26.0402 12.4283L21.7702 16.6983L23.4269 18.355L27.6969 14.085C27.8911 14.1366 28.0909 14.1641 28.2919 14.1667C28.9107 14.1667 29.5042 13.9208 29.9418 13.4832C30.3794 13.0457 30.6252 12.4522 30.6252 11.8333C30.6252 11.2145 30.3794 10.621 29.9418 10.1834C29.5042 9.74583 28.9107 9.5 28.2919 9.5ZM14.3502 12.58C14.2412 12.4719 14.1119 12.3863 13.9698 12.3283C13.8276 12.2702 13.6754 12.2408 13.5219 12.2417C13.2158 12.243 12.9225 12.3645 12.7052 12.58C11.6736 13.5413 10.8462 14.7005 10.2723 15.9885C9.69838 17.2765 9.38979 18.6668 9.36492 20.0767C9.34004 21.4865 9.59939 22.8869 10.1275 24.1944C10.6556 25.5018 11.4416 26.6895 12.4387 27.6865C13.4357 28.6836 14.6234 29.4696 15.9308 29.9977C17.2383 30.5258 18.6387 30.7852 20.0485 30.7603C21.4584 30.7354 22.8487 30.4268 24.1367 29.8529C25.4247 29.279 26.5839 28.4516 27.5452 27.42C27.765 27.2046 27.8908 26.9111 27.8952 26.6033C27.8946 26.449 27.8633 26.2963 27.8032 26.1541C27.7431 26.0119 27.6554 25.8831 27.5452 25.775L14.3502 12.58Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDth);
export default __webpack_public_path__ + "static/media/dth.63897fe231e6c4eaf89b4270ecf89457.svg";
export { ForwardRef as ReactComponent };